import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Alert,
  Box,
} from "@mui/material";
import TableViewIcon from "@mui/icons-material/TableView";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InventoryIcon from "@mui/icons-material/Inventory";
import SendIcon from "@mui/icons-material/Send";

const OverviewTab = () => (
  <Card>
    <CardContent>
      <Typography variant="h5" gutterBottom>
        Welcome to PrepBusiness Inbound Manager
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        This service automates the inbound workflow by connecting PrepBusiness
        Google Sheets, Amazon SP-API, and SellerLogic. It streamlines the
        process from request to shipment creation.
      </Typography>

      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={3}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <TableViewIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Google Sheets</Typography>
              <Typography variant="body2" color="text.secondary">
                Receives inbound requests directly from PrepBusiness Sheets
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <WarningAmberIcon color="warning" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Hazmat Check</Typography>
              <Typography variant="body2" color="text.secondary">
                Validates ASINs for hazardous materials using Amazon SP-API
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <InventoryIcon color="info" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">SellerLogic</Typography>
              <Typography variant="body2" color="text.secondary">
                Identifies correct SKUs and bundles items for optimization
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card variant="outlined" sx={{ height: "100%" }}>
            <CardContent sx={{ textAlign: "center" }}>
              <SendIcon color="success" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="h6">Submission</Typography>
              <Typography variant="body2" color="text.secondary">
                Submits created inbound packages to PrepBusiness
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Workflow Configuration
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        To ensure the inbound automation runs correctly, please verify the
        following configurations:
      </Typography>
      <Box component="ol" sx={{ pl: 3 }}>
        <li>
          <strong>Google Credentials:</strong> Ensure the service account has
          access to the target PrepBusiness Google Sheets.
        </li>
        <li>
          <strong>Amazon SP-API:</strong> Verify that active credentials are set
          to perform real-time Hazmat checks on incoming ASINs.
        </li>
        <li>
          <strong>SellerLogic:</strong> Configure access to allow for accurate
          SKU identification and bundling logic.
        </li>
        <li>
          <strong>PrepBusiness API:</strong> Confirm that the API key is active
          for submitting inbound packages back to PrepBusiness.
        </li>
      </Box>

      <Alert severity="info" sx={{ mt: 3 }}>
        <Typography variant="body2">
          <strong>System Note:</strong> This service relies on the availability
          of third-party APIs (Google, Amazon, SellerLogic). Ensure your quotas
          and API tokens are up to date in the respective Credential tabs.
        </Typography>
      </Alert>
    </CardContent>
  </Card>
);

export default OverviewTab;
